import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ContractInboundPhone } from '../../_types/contract-inbound-phone';
import { ContractInboundPhonesService } from '../../_services/contracts-inbound-phones.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-inbound-phone-detail',
    templateUrl: './inbound-phone-detail.component.html',
    styleUrls: ['./inbound-phone-detail.component.scss'],
    standalone: false
})
export class ContractInboundPhoneDetailComponent {
  public contractInboundPhoneFormGroup!: RxFormGroup;

  public contractInboundPhone: ContractInboundPhone = new ContractInboundPhone();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private contractInboundPhonesService: ContractInboundPhonesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.contractInboundPhoneFormGroup = this.formBuilder.formGroup<ContractInboundPhone>(this.contractInboundPhone) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.contractInboundPhoneId) {
      this.loadContractInboundPhone(this.config.data.contractInboundPhoneId);
    } else {
      this.contractInboundPhone.contractId = this.config.data.contractId;
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractInboundPhone(id: string) {
    this.contractInboundPhone = await firstValueFrom(this.contractInboundPhonesService.get(id));
    this.contractInboundPhoneFormGroup.patchValue(this.contractInboundPhone);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.contractInboundPhoneFormGroup);
    if (valid) {
      this.contractInboundPhone = Object.assign(this.contractInboundPhone, this.contractInboundPhoneFormGroup.value);

      await this.contractInboundPhonesService.save(this.contractInboundPhone).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Teléfono guardado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la especialidad' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el teléfono?",
      header: "Eliminar teléfono",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractInboundPhonesService.delete(this.contractInboundPhone.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Teléfono eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  public phoneFilter: RegExp = /^[0-9 +]*$/;
}
